export const page = function( $scope,cartManager ) {
    $scope.cartManagerCtrl = cartManager;
};